import * as Yup from 'yup';

export const relatedArticlesStepSchema = Yup.object({
    relatedArticles: Yup.array()
        .of(Yup.object({
            id: Yup.string().required('ID artykułu jest wymagane'),
            title: Yup.string().required('Tytuł artykułu jest wymagany')
        }))
        .default([]),
        // .required('Wybierz przynajmniej jeden powiązany artykuł')
        // .min(1, 'Wybierz przynajmniej jeden powiązany artykuł'),
});
